






























































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import '@/compiled-icons/check';
import '@/compiled-icons/error-outline';

@Component({
  name: 'dynamic-document-export-template',
  components: {
  }
})
export default class DynamicDocumentExportTemplate extends Vue {

  @Prop() value!: string;

  step = 1;
  exportStatus: 'RUNNING' | 'FAILED' | 'DONE' | null = null;
  exportResult: string | null = null;

  mounted() {
    if (this.value) {
      this.exportStatus = 'RUNNING';
      HTTP_SERVICE_INSTANCE.getAxios().get(`/dynamicdocuments/v0/documents/${this.value}`).then((result) => {
        this.exportStatus = 'DONE';
        this.exportResult = result.data;
        setTimeout(() => {
          this.step = 2;
        }, 100);
      }, (error) => {
        this.exportStatus = 'FAILED';
      });
    }
  }

}
